<template>
  <div class="renewal_page">
    <!-- 搜索框 -->
    <div class="search_bar">
      <div class="search_inp">
        <span class="search_icon"></span>
        <input  v-model="queryParams.searchName" type="text" placeholder="投被保险人/保单号/产品名称" @input="debounceFetch(false)">
      </div>
      <ul class="tab_bar" v-if="!isShowMore">
        <li v-for="(item,index) in tabList" :key="index" @click="changeTab(index)">
          <span class="tab_name" :class="{active: activeBarIndex == index}">{{item.text}}</span>
          <img v-if="activeBarIndex == index" src="../../../assets/image/nsale/tabSelected.png" class="tab_selected"/>
        </li>
      </ul>
      <div class="date_select"  v-else>
        <div class="date_left" @click="chooseDate()">
          <img src="../../../assets/image/nsale/date.png" alt="">
          <span class="date_choose" v-if="!queryParams.startDate && !queryParams.endDate">时段选择</span>
          <span v-else class="date_choose">
            <span v-if="queryParams.startDate">{{moment(queryParams.startDate).format('YYYY/MM/DD')}}</span>
            <span>-</span>
            <span v-if="queryParams.endDate">{{moment(queryParams.endDate).format('YYYY/MM/DD')}}</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 订单列表 -->
    <div class="order_list" v-if="orderList.length > 0">
      <div class="order_item" v-for="(item,index) in orderList" :key="index">
        <div class="item_line">
          <span class="title_">{{item.productName}}</span>
          <!-- 距离交费日多少天 -->
          <span class="tips_ tips_yellow" v-if="item.daysBeforePayment && item.daysBeforePayment > 0 && item.viewState == '1'">交费日剩余{{item.daysBeforePayment}}天</span>
          <!-- 距离宽限期多少天 -->
          <span class="tips_ tips_red" v-else-if="item.daysBeforeGracePeriod && item.daysBeforeGracePeriod > 0 && item.viewState == '1'">宽限日剩余{{item.daysBeforeGracePeriod}}天</span>
          <span class="tips_ tips_red" v-else-if="item.viewState == '2' || item.viewState == '3'">{{item.viewStateDesc}}</span>
        </div>
        <div class="item_line2">
          <span>投保人：</span>
          <span>{{item.holderName}}</span>
        </div>
        <div class="item_line2">
          <span>投保时间：</span>
          <span>{{item.effectiveDate}}</span>
        </div>
        <div class="item_line2">
          <span>保单号：</span>
          <span>{{item.policyNo}}</span>
        </div>
        <div class="item_line2">
          <span>保费：</span>
          <span>{{item.totalPremium}}</span>
        </div>
        <div class="item_bottom">
          <div class="item_left">
            <div class="item_time">
              <span>到期时间：</span>
              <span>{{item.expireDate}}</span>
            </div>
            <!-- 不可续保才需要展示原因 -->
            <p v-if="activeBarIndex == 1" class="item_reason">不可续保原因：{{item.nonRenewalReason}}</p>
          </div>
          <button class="grey_" v-if="item.viewState == '3'" @click="deletePolicyByUserId(item.policyId)">删除</button>
          <button :class="item.viewState == '3' || activeBarIndex == 1 ? 'red_': 'grey_'" @click="showDetail(item.policyId,item.insuranceType,item)">查看详情</button>
          <button class="red_" v-if="item.viewState == '1' && item.showRenewal && !item.showRecommend && item.insuranceType == 2 && !item.theTnsuredOverAge" @click="oneClickRenewal(item)">一键续保</button>
          <button class="red_" @click="renewalRecomand(item)" v-if="item.showRecommend">续保推荐</button>
          <button class="red_" v-if="item.viewState == '1' && item.insuranceType == '1'" @click="getReminderText(item)">复制续保提醒</button>
          <button class="red_" v-if="item.showRenewalGuide" @click="showRenawalGuide(item)">续保指引</button>
        </div>
      </div>
    </div>
    <div class="order_list_empty" v-else>
      无相关的数据
    </div>
    <p v-if="nomore && orderList.length > 0" class="nomore">没有更多了</p>
    <!-- 更多未续保保单 -->
    <div class="more_" v-if="!queryParams.morePolicy && activeBarIndex == 0 && hasMore">
      <button class="more_btn" @click="showMore()">
        查看3月前未续保保单
      </button>
    </div>
    <!-- 时段选择 -->
    <div class="mask_bg" v-if="isShowMask">
      <div class="mask_con">
        <p class="title_">
          <span class="date_text">时段选择</span>
          <span class="date_cancel" @click="cancel">取消</span>
        </p>
        <p class="date_select">
          <input type="text" placeholder="请选择时间" readonly @click="dateChange('startDate')" v-model="queryParams.startDate">
          <span class="to_">至</span>
          <input type="text" placeholder="请选择时间" readonly @click="dateChange('endDate')" v-model="queryParams.endDate">
        </p>
        <div class="date_btns">
          <button class="reset_btn" @click="reset">重置</button>
          <button class="comfirm_btn" @click="confirm">确定</button>
        </div>
      </div>
    </div>
    <!-- 推荐续保 -->
    <!-- <div class="recommend_mask" v-if="isShowRecoman">
      <div class="recommend_box">
        <p class="close_" @click="closeRecommend">x</p>
        <div class="recommend_item" v-for="(item,index) in recomanList" :key="index">
          <div class="pro_left">
            <img :src="item.productPicuter" alt="">
            <p class="short_name">
              {{item.companyAbbreviation}}
            </p>
          </div>
          <div class="pro_right">
            <div class="pro_right_top">
              <p class="pro_name">
                {{item.productName}}
              </p>
              <div class="pro_tag">
                <p v-for="(item2,index2) in item.riskLiabilityVoList" :key="index2">
                  {{`${item2.riskLiability}：${item2.sumAssured}`}}
                </p>
              </div>
            </div>
            <div class="pro_right_bottom">
              <div class="foot_">
                <p><span class="unit_">¥</span><span class="price_">{{item.productPrice}}</span><span class="unit_2">元起</span></p>
                <button @click="getWeChatProduct(item.productCode)">点击续保</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 推荐续保 -->
    <div class="mask" v-if="renewalGuideBtnShow" @click.self="renewalGuideBtnShow=false">
      <div class="renewal-guide">
        <h3 class="pro-title">续保指引</h3>
        <p class="close_" @click="renewalGuideBtnShow=false">x</p>
        <div class="scroll-box" v-html="renawalGuideContent"></div>
      </div>
    </div>
    <!-- 日期选择 -->
    <div class="calendar_mask" v-if="isShowCalendar">
        <div class="calendar">
          <p class="calendar_title">
            <span class="cancel_" @click="calendarCancel()">取消</span>
            <span class="choose_date">选择时间</span>
            <span class="confim_" @click="calendarConfirm()">确定</span>
          </p>
          
          <p class="calendar_current_month">
            <span class="pre_month" @click="prevMonth">
              <img class="arrow_" src="../../../assets/image/nsale/caret-left.png" alt="">
            </span>
            <span class="current_date">{{dateYYMM}}</span>
            <span class="next_month" @click="nextMonth">
              <img class="arrow_" src="../../../assets/image/nsale/caret-right.png" alt="">
            </span>
          </p>
          <!-- 星期 -->
          <div class="calendar-week clear">
            <div v-for="(item,index) in calendarTileArr" :key="index" class="calendar-week-item">{{item}}</div>
          </div>
          <!-- 日期 -->
          <div class="calendarDate">
            <div v-for="(item,index) in calendarDateTempArr"  :key="index" class="date">
              <div v-if="moment(item.dateFormat).diff(moment(firstDataOfCurrentMonth),'days') < 0" class="date_con" :class="{active : activeDateIndex === index}" @click="clickDay(item,index)">
                <span></span>
              </div>
              <div v-else-if="moment(maxDate).diff(moment(item.dateFormat),'days') >= 0" class="date_con" :class="{active : activeDateIndex === index}" @click="clickDay(item,index)">
                <span>{{item.day}}</span>
              </div>
              <div class="date_con" v-else>
                <span class="disabled_">{{item.day}}</span>
              </div>
            </div>
          </div>
          <div class="line_"></div>
          <div class="btns">
            <button class="today_" @click="isShowCalendar = false">取消</button>
            <button class="confirm_" @click="calendarConfirm">确定</button>
          </div>
        </div>
    </div>
    <div class="fixbg_" v-if="showContent" @click="showContent=false">
      <div class="con_" @click.stop>
        <p class="title_">续保提醒</p>
        <div class="content_">
          {{message}}
        </div>
        <span class="btn_" v-clipboard:copy="message" v-clipboard:success="firstCopySuccess" v-clipboard:error="firstCopyError">复制续保提醒</span>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from '@/utils/debounce.js';
import api from "@/utils/api";
import moment from 'moment';
const positions = ['bottom']
let cur = 0
let maxDate = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
let strDatepart = maxDate.split("-");
export default {
  data() {
    document.title = '续保订单'
    let { year, month, day } = this.getNewDate(new Date(strDatepart[0], strDatepart[1]-1,1));
    return {
      tabList: [
        {
          value: 1,
          text: '可续保'
        },
        {
          value: 2,
          text: '不可续保'
        }
      ],
      renewalGuideBtnShow: false, // 续保指引弹框
      renawalGuideContent: '', // 续保指引内容
      activeBarIndex: 0,
      orderList: [],
      isShowMore: false,
      isShowMask: false,
      isShowRecoman: false, // 是否展示续保推荐
      isShowCalendar: false,
      dateType: '', // 选择开始或者结束时间
      time: { year, month, day },
      calendarTileArr: ["S", "M", "T", "W", "T", "F", "S"],
      resultDateList: [],
      calendarDateTempArr: [],
      dateYYMM: '',
      position: '',
      activeDateIndex: '',
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        searchName: '',
        renewalType: '1', // 1 可续保 2 不可续保 默认查询可续保列表
        userId: '',
        morePolicy: false,
        startDate: '',
        endDate: '',
        pages: ''
      },
      mainId: '',
      userId: '',
      pNo: '',
      productCode: '',
      showContent:false,
      message:"",
      recomanList: [], // 推荐产品列表
      maxDate: moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD'),
      clientHeight: 0, // 可视区的高度
      scrollTop: 0, // 滚动条滚动时，距离顶部的距离
      scrollHeight: 0, // 滚动条的总高度
      nomore: false,
      firstDataOfCurrentMonth: year + '-' + (month + 1) + '-' + day,
      hasMore: false, // 是否展示查看未续保保单按钮
    }
  },
  methods: {
    moment,
    // 查询续保指引
    showRenawalGuide(item) {
      api.getRenewalGuide({ productCode: item.productCode}).then((res) => {
        let { returnCode, returnMsg, content } = res.data;
        if(returnCode !== '0000') {
          this.$toast(returnMsg);
          return;
        }
        this.renawalGuideContent = content;
        this.renewalGuideBtnShow = true;
      })
    },
    changeTab(index) {
      window.scrollTo(0,0)
      this.activeBarIndex = index
      // this.queryParams.searchName = ''
      this.queryParams.morePolicy = false
      if (this.activeBarIndex == 0) {
        this.queryParams.renewalType = '1'
      } else {
        this.queryParams.renewalType = '2'
      }
      this.fetchData(false)
    },
    debounceFetch: debounce(function(props) {
      this.nomore = false
      this.fetchData(false)
    }, 1000),
    fetchData(flag) {
      console.log('----------');
      if (!flag) {
        this.clearData();
      }
      this.getRenewalList(flag)
    },
    clearData() {
      this.queryParams.pageNum = 1
      this.queryParams.pages = ''
      this.nomore = false
    },
    showMore() {
      this.$router.push({
        path: '/bs/pastRenewal',
        query: this.$route.query
      });
      // this.isShowMore = true
      // this.queryParams.renewalType = '1'
      // this.queryParams.morePolicy = true
      // this.queryParams.pages = ''
      // this.fetchData(false)
    },
    chooseDate() {
      this.isShowMask = true
    },
    dateChange(dateType) {
      this.isShowCalendar = true
      this.dateType = dateType
      this.visibleCalendar()
    },
    cancel() {
      this.isShowMask = false
    },
    reset() {
      this.queryParams.startDate = ''
      this.queryParams.endDate = ''
    },
    confirm() {
      this.isShowMask = false
      this.fetchData(false)
    },
    renewalRecomand(item) {
      let url = `https://wechatpay.yutai365.com/wechatlink/renewal/changProduct?policyId=${item.policyId}&renewalProductCodes=${item.renewalProductCodes}`;
      if (window.location.href.indexOf('run4wd') > -1 || window.location.href.indexOf('localhost') > -1) {
        url =  `http://test.ssish.com/wechatlink/renewal/changProduct?policyId=${item.policyId}&renewalProductCodes=${item.renewalProductCodes}`;
      }
      window.location.href = url;
      // let params = {
      //   productCode: productCode,
      //   mainId: this.mainId,
      //   userId: this.userId
      // }
      // this.isShowRecoman = true
      // api.getRenewalProducts(params).then(res => {
      //   this.recomanList = res.data.content
      //   console.log(this.recomanList);
      // })
    },
    closeRecommend() {
      this.isShowRecoman = false
    },

    // 当前日期
    currentDate() {
      let t=new Date()
      let day=t.getDate()
      let mon=t.getMonth() + 1
      if (mon < 10) {
        mon = '0' + mon 
      }
      if (day < 10) {
        day = '0' + day
      }
      var year=t.getFullYear()
      return year + '' + mon  +  '' +day
    },
    // 当前日期下一个月时间
    getNextMonth() {
      var t=new Date()
      var day=t.getDate() //获取当前日期的日
      var month=t.getMonth() + 1 //获取当前日期的月份
      var year=t.getFullYear() //获取当前日期的年份
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      if (day2 < 10) {
        day2 = '0' + day2
      }
      var t2 = year2 + '' + month2 + '' + day2;
      this.firstDataOfCurrentMonth = year + '-' + month  + '-1'
      return t2;
    },
    // 日历弹框展示
    showPopup(checkUnitCode,supplierId,hospitalId) {
      this.supplierId = supplierId
      this.hospitalId = hospitalId
      this.isShowCalendar = true
      this.checkUnitCode = checkUnitCode
      this.visibleCalendar()
      this.position = positions[cur++]
      if (cur === positions.length) {
        cur = 0
      }
      const component = this.$refs.myPopup4
      component.show()
    },
    // 日历弹框隐藏
    hidePopup() {
      this.isShowCalendar = false
      this.$refs.myPopup4.hide()
    },
    // 获取新的日期
    getNewDate(date) {
      let year = date.getFullYear()
      let month = date.getMonth()
      let day = date.getDate()
      return { year, month, day }
    },
    // 是否是当前月
    isCurrentMonth(date) {
      let { year: currentYear, month: currentMonth } = this.getNewDate(new Date(this.time.year, this.time.month, 1))
      let { year, month } = this.getNewDate(date)
      return currentYear == year && currentMonth == month
    },
    // 是否是今天 
    isCurrentDay(date) {
      let { year: currentYear, month: currentMonth, day: currentDay } = this.getNewDate(new Date());
      let { year, month, day } = this.getNewDate(date);
      return currentYear == year && currentMonth == month && currentDay == day;
    },
    // 上一个月
    prevMonth() {
      let prevMonth = new Date(this.time.year, this.time.month, 1)
      prevMonth.setMonth(prevMonth.getMonth() - 1);
      this.time = this.getNewDate(prevMonth)
      this.firstDataOfCurrentMonth = moment(prevMonth).format('YYYY-MM-DD')
      this.visibleCalendar()
    },
    // 下一个月
    nextMonth() {
      let nextMonth = new Date(this.time.year, this.time.month, 1)
      nextMonth.setMonth(nextMonth.getMonth() + 1)
      this.time = this.getNewDate(nextMonth)
      let { year ,month ,day} = this.time
      this.firstDataOfCurrentMonth = moment(nextMonth).format('YYYY-MM-DD')
      console.log(year,month,day);
      this.visibleCalendar()
    },
    // 回到今天
    today() {
      // let time = this.getNewDate(new Date());
      // this.activeDateIndex = this.calendarDateTempArr.findIndex(item => item.day == time.day && item.month == time.month + 1 )
      // console.log('今天',this.time);
    },
    getMonthDayTotal(year, month){
       // 初始化date为月份的第0天，由于JavaScript中day的范围为1~31中的值，所以当设为0时，会向前一天，也即表示上个月的最后一天
       let nextMonth = month + 1;
       let date = new Date(year, nextMonth, 0);
       return date.getDate();
    },
    // 获取新的日期
    getNewDate(date) {
      let year = date.getFullYear()
      let month = date.getMonth()
      let day = date.getDate()
      return { year, month, day }
    },
    // 点击日期，预约体检时间
    clickDay(item,index) {
      if (this.activeDateIndex === index) {
        this.activeDateIndex = ''
        this.queryParams[this.dateType] = ''
      } else {
        this.activeDateIndex = index
        this.queryParams[this.dateType] = item.dateFormat
      }
    },
    visibleCalendar() {
      this.calendarDateTempArr = []
      // let strDatepart = this.maxDate.split("-");
      // 获取当前时间，年，月
      let { year, month, day } = this.getNewDate(new Date(this.time.year, this.time.month, 1));
      // let { year, month, day } = this.getNewDate(new Date(strDatepart[0], strDatepart[1]-1, 1));
      let m = month + 1
      // if (m < 10) {
      //   m = '0' + m
      // }
      this.dateYYMM = year + '年' + m + '月'
      // 获取当前月的第一天
      let currentMonthFirstDay = new Date(year, month, 1);
      // 获取当前月的第一天是星期几
      let currentMonthFirstDayWeekDay = currentMonthFirstDay.getDay()
      // 总天数 =  当前月天数 + 当前月的第一天是星期几
      let dayNum = this.getMonthDayTotal(year, month) + currentMonthFirstDayWeekDay

      // todo 调用后端接口，获取本月可预约情况 
      // let param = {
      //   supplierId: this.supplierId,
      //   code:this.checkUnitCode,
      //   beginDate:this.currentDate(),
      //   endDate:this.getNextMonth(),
      //   customerId: this.addAppointmentInfo.customerId || this.choosePerson.id,
      //   servicepackageId: this.addAppointmentInfo.id || this.healthInfo.servicepackageId,
      //   chooseList: this.chooseIdList,
      //   payList: this.payIdList,
      // }
      // api.getScheduleByCode(param).then(res => {
        // this.resultDateList = res.data.content
        // if (res.data.content == null) {
        //   this.resultDateList = []
        // }
        for (let i = 0; i < dayNum; i++) {
        let dateDay = new Date(currentMonthFirstDay.getTime() + ((i - currentMonthFirstDayWeekDay) * 24 * 60 * 60 * 1000))

        //判断dateDay是否与后端返回的日期列表匹配，如果匹配继续判断是否可以预约，和处理状态

        let year = dateDay.getFullYear()
        let month = dateDay.getMonth() + 1
        let day = dateDay.getDate()
        // if (month < 10) {
        //   month = '0' + month
        // }
        // if (day < 10) {
        //   day = '0' + day
        // }
        let fullDate = year + '' + month + ''  + day
        let enableClick = false
        let personCount = 0
        this.resultDateList.forEach(item => {
          if (item.scheduleDate == fullDate) {
            enableClick = true
            personCount = item.personCount
            return
          }
        })
        this.calendarDateTempArr.push({
          date: dateDay,
          year: year,
          month: month,
          day: day,
          statusIndex: 1, // 状态，根据后端返回的数据决定状态值，1，假如是后端传回的状态
          enableClick: enableClick,
          fullDate: fullDate,
          personCount: personCount,
          dateFormat: year + '-' + month + '-' + day
        });

        this.activeDateIndex = this.calendarDateTempArr.findIndex((item,index) => {
          if (this.dateType == 'startDate') {
            return item.dateFormat == this.queryParams.startDate
          } else if (this.dateType == 'endDate') {
            return item.dateFormat == this.queryParams.endDate
          }
          return ''
        })
      }
      // })
    },
    calendarCancel() {
      this.isShowCalendar = false
    },
    calendarConfirm() {
      this.isShowCalendar = false
    },
    // 查询续保订单
    getRenewalList(flag) {
      if (!flag) {
        this.clearData()
      }
      this.queryParams.userId = this.userId
      console.log(this.queryParams);
      api.getRenewalList(this.queryParams).then(res => {
        if (!flag) {
          this.orderList = res.data.content.list || []
        } else {
          this.orderList = this.orderList.concat(res.data.content.list || [])
        }
        this.hasMore = res.data.content.hasMore
        // this.orderList = res.data.content.list || []
        this.queryParams.pages = Math.ceil((res.data.content.total || 0) / this.queryParams.pageSize);
        this.queryParams.total = res.data.content.total
      })
    },
    // 一键续保
    oneClickRenewal(policyData) {
      let params = {
        policyId: policyData.policyId,
        productCode: policyData.productCode
      }
      api.getRenewalUrl(params).then(res => {
        window.location.href = res.data.content
      })
    },
    showDetail(policyId,insuranceType,data) {
      let isOneClickRenewal = 'N'
      if (data.viewState == '1' && data.isOneClickRenewal == 'Y' && !data.showRecommend && data.insuranceType == 2 && !data.theTnsuredOverAge) {
        isOneClickRenewal = 'Y'
      }
      console.log(data.electronicInsurance, 591)
      this.$router.push({
        path: '/bs/policyDetail',
        query: {
          policyId: policyId,
          insuranceType: insuranceType,
          isOneClickRenewal:isOneClickRenewal,
          electronicInsurance: data.electronicInsurance
        }
      })
    },
    firstCopySuccess() {
      this.$toast('复制成功');
    },
    firstCopyError() {
      this.$toast('请手动复制提醒内容');
    },
    getReminderText(policyData) {
      let params =  {
        mainId: this.mainId,
        pNo: policyData.policyNo,
        productCode: policyData.productCode
      }
      api.getReminderText(params).then(res => {
        this.message = res.data.content
        this.showContent = true
      })
    },
    deletePolicyByUserId(policyId) {
      let params = {
        policyId: policyId,
        userId:  this.userId
      }
      api.deletePolicyByUserId(params).then(res => {
        this.$toast('删除成功')
        this.queryParams.pageNum = 1
        this.getRenewalList()
      })
    },
    getWeChatProduct(productCode) {
      let params = {
        productCode: productCode,
        userId: this.userId
      }
      api.getWeChatProduct(params).then(res => {
        let state = res.data.content.state
        let url = res.data.content.wechatlinkUrl
        let productCode = res.data.content.productCode
        let msg = res.data.content.msg
        if (state == 1) {
          window.location.href = url
        } else if (state == 2) {
          this.judgeOnlyPcOrCpsAndGetPosterUrl(productCode,url)
        } else if (state == 3) {
          this.$toast(msg)
        }
      })
    },
    judgeOnlyPcOrCpsAndGetPosterUrl(productCode,url) {
      api.judgeOnlyPcOrCpsAndGetPosterUrl(productCode).then(res => {
        let judgeFlag = res.data.content.judgeFlag
        let pcOrCpsPosterUrl = res.data.content.posterUrl || '';
        if(judgeFlag=='1'){
          this.$router.push({
            path: '/bs/PCPolicyGuide',
            query: {
              pcOrCpsPosterUrl: encodeURIComponent(pcOrCpsPosterUrl)
            }
          })
          return;
        }
        window.location.href = url;
      })
    },
    calendarConfirm() {
      this.isShowCalendar = false
      this.activeDateIndex = ''
    },
    listenerFunction() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;// 滚动条滚动时，距离顶部的距离
      this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;// 可视区的高度
      this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;// 滚动条的总高度
      if(this.scrollTop+this.clientHeight>=this.scrollHeight){
        // window.scrollTo(this.scrollTop - 20, 0);
        this.timer=setTimeout(()=>{   //延迟500ms加载数据
          console.log(this.queryParams);
          this.pageChange();
        },500)
      }
    },
    pageChange() {
      if(this.queryParams.pageNum < this.queryParams.pages){
          this.queryParams.pageNum++;
          this.fetchData(true)
      }else{
          this.nomore=true
      }
    },
  },
  mounted() {
    let { mainId,userId } = this.$route.query
    this.mainId = mainId
    this.userId = userId
    this.getRenewalList()
  },
  created() {
    window.addEventListener('scroll', this.listenerFunction)
  },
  destroyed() {
    window.removeEventListener('scroll', this.listenerFunction)
  },
}
</script>
<style lang="scss" scoped>
.renewal_page {
  background: #F8F8F8;
  padding: 80px 0 60px;
  min-height: 100vh;
  .search_bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0  20px;
    background: #fff;
    .search_inp {
      position: relative;
      background: #F5F5F5;
      height: 35px;
      border-radius: 7px;
      margin-top: 10px;
      .search_icon{
        position: absolute;
        top: 50%;
        left: 11px;
        transform: translateY(-43%);
        width:13px;
        height:13px;
        background:url(../../../assets/image/nsale/search2.png) center center no-repeat;
        background-size:100% 100%;
      }
      input {
        position: absolute;
        width: 90%;
        height: 35px;
        top: 0;
        left: 30px;
        background: #F5F5F5;
        border-radius: 7px;
        font-size: 12px;
        color: #ccc;
        &:focus {
          outline: none;
          border: none;
          color: #333;
        }
      }
    }
    .tab_bar {
      display: flex;
      align-items: center;
      height: 44px;
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        .tab_name {
          font-size: 13px;
        }
        .tab_selected {
          width: 19px;
          height: 5px;
          margin-top: 3px;
        }
        .active {
          font-size: 15px;
          font-weight: 500;
          line-height: 21px;
        }
      }
    }
    .date_select {
      display: flex;
      height: 49px;
      .date_left {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin: 0 3px 0 16px;
        }
        .date_choose {
          color: #333333;
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }
  .order_list  {
    margin-top: 20px;
    border-radius: 7px;
    padding: 0  20px;
    .order_item {
      background: #fff;
      padding: 18px 16px 13px;
      border-radius: 7px;
      margin-bottom: 15px;
      .item_line {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        .title_ {
          line-height: 23px;
          color: #333333;
          font-size: 15px;
          font-weight: 600;
          text-align: left;
          flex: 5;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .tips_ {
          flex: 3;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          text-align: right;
          line-height: 20px;
        }
        .tips_yellow {
          color: #FFAA4D;
        }
        .tips_red {
          color: #FF7C6D;
        }
      }
      .item_line2 {
        color: #666;
        font-size: 12px;
        text-align: left;
        margin-top: 4px;
        height: 17px;
        line-height: 17px;
      }
      .item_bottom {
        margin-top: 17px;
        border-top: 1px solid #ECECEC;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 17px;
        .item_left {
          // flex: 2;
          // flex-wrap: wrap;
          text-align: left;
          .item_time {
            color: #666;
            font-size: 12px;
            line-height: 17px;
            margin-bottom: 4px;
          }
          .item_reason {
            color: #999999;
            font-size: 12px;
            line-height: 17px;
          }
        }
        // .btns {
          // flex: 3;
          button {
            height: 27px;
            border-radius: 4px;
            border: none;
            min-width: 60px;
            &:focus {
              outline: none;
              border: none;
            }
          }
          .grey_ {
            background: #EAEAEA;
            color: #666666;
          }
          .red_ {
            background: var(--main-color);
            color: #fff;
          }
        // }
      }
      .mR10 {
        margin-right: 10px;
      }
    }
  }
  .order_list_empty {
    font-size: 14px;
    margin-top: 50px;
  }
  .nomore {
    font-size: 14px;
    color: #999;
  }
  .more_ {
    position: fixed;
    bottom: 14px;
    width: 100%;
    height: 45px;
    border-radius: 7px;
    padding: 0 20px;
    .more_btn {
      width: 100%;
      height: 100%;
      background: var(--background-color);
      border-radius: 7px;
      border: none;
      color: #fff;
      font-size: 15px;
      font-weight: 500;
      &:focus {
        outline: none;
        border: none;
      }
    }
  }
  .mask_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    .mask_con {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 224px;
      width: 100%;
      background: #fff;
      border-radius: 10px 10px 0px 0px;
      .title_ {
        position: relative;
        width: 100%;
        height: 45px;
        line-height: 45px;
        background: #F9F9F9;
        border-radius: 10px 10px 0px 0px;
        .date_text {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 15px;
          color: #333;
          text-align: center;
        }
        .date_cancel {
          position: absolute;
          right: 16px;
          font-size: 13px;
          color: #666666;
          text-align: right;
        }
      }
      .date_select {
        margin-top: 24px;
        input {
          width: 142px;
          height: 45px;
          background: #F9F9F9;
          border-radius: 7px;
          font-size: 13px;
          color: #999999;
          text-align: center;
          &:focus {
            outline: none;
          }
        }
        .to_ {
          color: #333333;
          font-size: 14px;
          margin: 0 20px;
        }
      }
      .date_btns {
        margin-top: 29px;
        .reset_btn {
          width: 136px;
          height: 45px;
          border-radius: 7px;
          border: 1px solid var(--main-color);
          background: #fff;
          color: var(--main-color);
          &:focus {
            outline: none;
          }
        }
        .comfirm_btn {
          width: 188px;
          height: 45px;
          background: var(--background-color);
          border-radius: 7px;
          border: none;
          color: #fff;
          margin-left: 10px;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .mask {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    .renewal-guide {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100vw;
      max-height: 66%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      border-radius: 20px 20px 0 0;
      padding: 20px;
      box-sizing: border-box;
    }
    .pro-title {
      font-size: 13px;
      color: #373737;
      font-weight: bold;
      margin-bottom: 14px;
    }
    .close_ {
      position: absolute;
      right: 20px;
      top: 20px;
      color: #000;
      font-size: 16px;
      text-align: right;
    }
    .scroll-box {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 10px;
    }
    ::v-deep p {
      text-align: left;
    }
    ::v-deep img {
      max-width: 100%;
    }
  }
  .recommend_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    .recommend_box {
      position: absolute;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;
      border-radius: 7px;
      background: #fff;
      padding-bottom: 46px;
      max-height: 350px;
      overflow: scroll;
      // height: 100px;
      .close_ {
        color: #000;
        font-size: 16px;
        text-align: right;
        margin: 16px 20px 15px 0;
      }
      .recommend_item {
        display: flex;
        margin: 0 29px 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .pro_left {
          position: relative;
          width: 88px;
          height: 112px;
          background: #eee;
          border-radius: 7px;
          img {
            width: 88px;
            height: 112px;
            border-radius: 7px;
          }
          .left_top_tag {
            position: absolute;
            top: 0;
            left: 0;
            width: 40px;
            height: 13px;
            line-height: 13px;
            background: var(--background-color);
            border-radius: 7px 0px 7px 0px;
            opacity: 0.9;
            color: #fff;
            font-size: 8px;
            text-align: center;
          }
          .short_name {
            position: absolute;
            bottom: 0;
            width: 88px;
            height: 18px;
            line-height: 18px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 0px 0px 7px 7px;
            font-size: 11px;
            color: #fff;
          }
        }
        .pro_right {
          margin-left: 9px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 80%;
          .pro_right_top {
            .pro_name {
              font-size: 15px;
              font-weight: 500;
              color: #333333;
              line-height: 21px;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .pro_tag {
              margin-top: 5px;
              font-size: 12px;
              color: #666;
              text-align: left;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .pro_right_bottom {
            .pro_score {
              width: 104px;
              height: 18px;
              line-height: 18px;
              background: #F0F0F0;
              border-radius: 10px;
              font-size: 11px;
              color: #666;
              font-weight: 500;
              text-align: center;
              // margin-bottom: 5px;
            }
            .foot_ {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 29px;
              .unit_ {
                font-size: 9px;
                color: #FF4A35;
              }
              .price_ {
                font-size: 18px;
                color: #FF4A35;
                line-height: 25px;
                margin: 0 2px 0;
              }
              .unit_2 {
                color: #666666;
                font-size: 10px;
              }
              button {
                width: 61px;
                height: 19px;
                background: var(--background-color);
                border-radius: 7px; 
                border: 0;
                color: #fff;
                font-size: 10px;
                font-weight: 500;
                &:focus {
                  outline: none;
                  border: none;
                }
              }
            }
          }
        }
      }
    }
  }
  .calendar_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    .calendar {
      width: 100%;
      height: 485px;
      position: absolute;
      background: #fff;
      bottom: 0;
      left: 0;
      border-radius: 10px 10px 0px 0px;
      // padding-bottom: 27px;
      .cancel_ {
        color: #666666;
        font-size: 13px;
      }
      .choose_date {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: #333333;
        font-size: 15px;
      }
      .confim_{
        color: var(--main-color);
        font-size: 13px;
      }
      .calendar_title {
        position: relative;
        padding: 0 17px;
        display: flex;
        justify-content: space-between;
        height: 45px;
        line-height: 45px;
        margin-bottom: 10px;
        background: #F9F9F9;
        border-radius: 10px 10px 0px 0px;
      }
      .calendar_current_month {
        // height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0 25px;
        .pre_month {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          line-height: 22px;
          background: #F3F3F3;
          border-radius: 5px;
          font-size: 8px;
        }
        .current_date {
          color: #333333;
          font-size: 12px;
          margin: 0 17px;
        }
        .next_month {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          line-height: 22px;
          background: #F3F3F3;
          border-radius: 5px;
          font-size: 8px;
        }
        .arrow_ {
          width: 8px;
          height: 8px;
        }
      }
      // .bgImg {
      //   width: 100%;
      // }
      // .hide {
      //   position: absolute;
      //   top: 30px;
      //   left: 30px;
      //   font-size: 16px;
      //   color: #8C8C8C;
      // }
      // .title {
      //   position: absolute;
      //   top: 35px;
      //   left: 50%;
      //   font-size: 16px;
      //   transform: translate(-50%)
      // }
      .calendar-week {
        width: 100%;
        // position: absolute;
        top: 74px;
        font-size: 15px;
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px;
        padding: 0 20px;
      }
      .calendar-week-item {
        width: 14.285%;
        text-align: center;
        display: inline-block;
        color: rgba(52, 72, 94, 0.54);
        font-size: 12px;

      }
      .right {
        position: absolute;
        top: 35px;
        right: 100px;
        width: 16px;
        height: 16px;
      }
      .left {
        position: absolute;
        top: 35px;
        left: 100px;
        width: 16px;
        height: 16px;
      }
      .calendarDate {
        width: 100%;
        padding: 0 20px;
        // border-bottom: 1px solid #E7E7E7;
        // position: absolute;
        // top: 105px;
        text-align: left;
        .date {
          display: inline-block;
          width: 14.285%;
          font-size: 11px;
          color: #666666;
          // height: 45px;
          text-align: center;
          margin-bottom: 5px;
          
          &:last-child {
            margin-bottom: 30px;
          }
          &:nth-child(7n) {
            color: var(--main-color);
          }
          .date_con {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .free {
              margin-top: 10px;
              color: #4098F9;
            }
            .busy {
              margin-top: 10px;
              color: #FF6633;
            }
          }
        }
        .active {
          color: #fff;
          width: 34px;
          height: 34px;
          border-radius: 17px;
          margin-left: 6px;
          background: var(--background-color);
        }
        .disabled_ {
          color: #34485e8a;
          font-size: 11px;
        }
      }
      .line_ {
        margin: 0 20px 20px;
        height: 1px;
        background: #E7E7E7;
      }
      .btns {
        padding: 0 45px;
        display: flex;
        justify-content: space-between;
        button {
          width: 126px;
          height: 40px;
          border-radius: 5px;
          border: none;
          &:focus {
            outline: none;
            border: none;
          }
        }
        .today_ {
          color: #666666;
          background: #EAEAEA;
          
        }
        .confirm_ {
          color: #fff;
          background: var(--main-color);
        }
      }
      .call_ {
        position: absolute;
        bottom: 30px;
        left: 20%;
        font-size: 12px;
        .tel {
          color: #4167F2;
        }
      }
    }
  }
  .fixbg_{
    position:fixed;
    top:0;
    right:0;
    left:0;
    bottom:0;
    background-color:rgba(0,0,0,0.5);
    z-index:5;
    .con_{
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      left:0;
      right:0;
      width:259px;
      margin:0 auto;
      background-color:#fff;
      border-radius:14px;
      font-size:14px;
      padding: 19px 22px;
      box-sizing: border-box;
      .title_{
        font-size: 14px;
        font-weight:bold;
        text-align:center;
        font-family: PingFangSC-Semibold;
        color: #191919;
      }
      .content_{
        color: #3E3E3E;
        font-size: 12px;
        font-family: PingFangSC-Medium;
        line-height:18px;
        text-align:left;
        margin-top: 19px;
      }
      .btn_{
        width:212px;
        height: 33px;
        line-height: 33px;
        text-align:center;
        border-radius: 3px;
        display:block;
        margin-top: 23px;
        background-color:var(--main-color);
        color:#fff;
        font-size: 14px;
        font-family: PingFangSC-Regular;
      }
    }
  }
}
</style>

